import { Keypair } from "@solana/web3.js";
import { useMemo } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import type { Wallet } from "../../types/wallet";

export type ConnectedWallet = Wallet;

export function useConnectedWallet(): Wallet | undefined {
  const { publicKey, signTransaction, signAllTransactions } = useEnrichedWallet();
  return useMemo(
    () =>
      publicKey && signTransaction && signAllTransactions
        ? { publicKey, signTransaction, signAllTransactions, payer: Keypair.fromSeed(Buffer.alloc(32)) }
        : undefined,
    [publicKey, signTransaction, signAllTransactions],
  );
}
